import type { ReactElement } from 'react'
import type { IntlShape } from 'react-intl'

import GoogleIcon from '@icons/Google.icon'
import MicrosoftIcon from '@icons/Microsoft.icon'

// Visual brand for the primary SSO button — distinct from the provider id
// actually submitted (the brand's HRD_BRAND_PROVIDERS default).
export type SsoBrand = 'microsoft' | 'google'

const BRAND_VISUALS: Record<SsoBrand, { labelKey: string; icon: () => ReactElement }> = {
  microsoft: { labelKey: 'login.oidc.signInWithMicrosoft', icon: MicrosoftIcon },
  google: { labelKey: 'login.oidc.signInWithGoogle', icon: GoogleIcon },
}

// Runtime mirror of the SsoBrand union (types vanish at runtime) — keeps the
// client brand list checkable against the server's KNOWN_BRANDS parity test
// (see known-brands.test.ts).
export const ALL_SSO_BRANDS: readonly SsoBrand[] = Object.keys(BRAND_VISUALS) as SsoBrand[]

export const resolveBrandVisuals = (
  brand: SsoBrand,
  intl: IntlShape,
): { label: string; icon: ReactElement } => {
  const { labelKey, icon: Icon } = BRAND_VISUALS[brand]
  return { label: intl.formatMessage({ id: labelKey }), icon: <Icon /> }
}
